class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input');
    this.span = this.querySelector('[data-quantity]');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    // Listen for input changes and update the span
    this.input.addEventListener('change', () => {
      this.span.textContent = this.input.value;
    });
  }

  connectedCallback() {
    // Initialize the span with the initial value
    this.span.textContent = this.input.value;
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      // Update the span with the new value
      this.span.textContent = this.input.value;
    }
  }

}

customElements.define('quantity-input', QuantityInput);